// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_cabinet__Bisb from "../../core/Bisb.js";
import * as Buhta_cabinet__ClassifiersKogdList from "./ClassifiersKogdList.js";
import * as Buhta_cabinet__Dropdown from "../html/Dropdown.js";
import * as Buhta_cabinet__Kogd from "../../grpc/Kogd.js";
import * as Buhta_cabinet__Org from "../../models/Org.js";
import * as Buhta_cabinet__TaxMode from "../../models/TaxMode.js";
import * as Buhta_components__Text from "../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__GrpcState from "../../../../../packages/core/lib/GrpcState.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

const countries_0 = {
  code: /* COUNTRY_KAZ */1,
  name: "Казахстан",
  icon: JsxRuntime.jsx("img", {
        className: "w-6 h-6",
        src: StaticAsset.src("/static/icons/kz-round-24.svg")
      })
};

const countries_1 = {
  hd: {
    code: /* COUNTRY_KGZ */2,
    name: "Кыргызстан",
    icon: JsxRuntime.jsx("img", {
          className: "w-6 h-6",
          src: StaticAsset.src("/static/icons/kg-round-24.svg")
        })
  },
  tl: {
    hd: {
      code: /* COUNTRY_UZB */3,
      name: "Узбекистан",
      icon: JsxRuntime.jsx("img", {
            className: "w-6 h-6",
            src: StaticAsset.src("/static/icons/uz-round-24.svg")
          })
    },
    tl: /* [] */0
  }
};

const countries = {
  hd: countries_0,
  tl: countries_1
};

function Dropdowns$CountrySelect(Props) {
  let setCountryCode = Props.setCountryCode;
  const match = React.useState(function () {
        return Belt__Belt_List.getExn(countries, 0);
      });
  const setSelectedCountry = match[1];
  const selectedCountry = match[0];
  React.useEffect((function () {
          Curry._1(setCountryCode, selectedCountry.code);
        }), [selectedCountry]);
  const activator = function (param) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          selectedCountry.icon,
                          JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                children: selectedCountry.name
                              })
                        ],
                        className: "flex gap-3 items-center"
                      }),
                  JsxRuntime.jsx("img", {
                        className: "w-6 h-6",
                        src: StaticAsset.src("/static/icons/select-arrows.svg")
                      }),
                  JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                        className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                        children: "Страна"
                      })
                ],
                className: "rounded border border-gray-main px-4 py-2 flex justify-between relative items-center "
              });
  };
  const match$1 = React.useState(function () {
        return false;
      });
  const setIsDropdownShown = match$1[1];
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                    innerClassName: "mt-1",
                    align: "BottomCenter",
                    activator: activator,
                    background: "bg-white",
                    isDropdownShown: match$1[0],
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsx("div", {
                          children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(countries, (function (index, country) {
                                      const Key = "ot-" + String(index);
                                      return JsxRuntime.jsxs("div", {
                                                  children: [
                                                    country.icon,
                                                    JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                          children: country.name
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-2 px-4 py-[11px] hover:bg-gray-light cursor-pointer",
                                                  onClick: (function (param) {
                                                      Curry._1(setSelectedCountry, (function (param) {
                                                              return country;
                                                            }));
                                                      Curry._1(setIsDropdownShown, (function (param) {
                                                              return false;
                                                            }));
                                                    })
                                                }, Key);
                                    }))),
                          className: "py-2 flex flex-col"
                        })
                  })
            });
}

const CountrySelect = {
  countries: countries,
  make: Dropdowns$CountrySelect
};

function make(org_type) {
  return function (onOrgTypeSelect) {
    const match = React.useState(function () {
          return false;
        });
    const setIsDropdownShown = match[1];
    const isDropdownShown = match[0];
    const activator = function (param) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    Buhta_cabinet__Org.Type.toString(org_type) === "Тип предприятия" ? JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            className: "text-gray-medium",
                            children: Buhta_cabinet__Org.Type.toString(org_type)
                          }) : JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                            children: Buhta_cabinet__Org.Type.toString(org_type)
                          }),
                    isDropdownShown ? JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            src: StaticAsset.src("/static/icons/select-arrows-links.svg")
                          }) : JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                          })
                  ],
                  className: Cn.$plus("rounded border border-gray-main px-4 py-[11px] mt-6 flex justify-between relative items-center", Cn.on("border-links", isDropdownShown))
                });
    };
    return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                align: "BottomCenter",
                activator: activator,
                background: "bg-white mt-1",
                isDropdownShown: isDropdownShown,
                setIsDropdownShown: setIsDropdownShown,
                children: JsxRuntime.jsx("div", {
                      children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                hd: /* ORG_TYPE_IP */1,
                                tl: {
                                  hd: /* ORG_TYPE_TOO */2,
                                  tl: {
                                    hd: /* ORG_TYPE_TDO */3,
                                    tl: {
                                      hd: /* ORG_TYPE_PK */4,
                                      tl: {
                                        hd: /* ORG_TYPE_AO */5,
                                        tl: {
                                          hd: /* ORG_TYPE_OAO */6,
                                          tl: {
                                            hd: /* ORG_TYPE_ZAO */7,
                                            tl: {
                                              hd: /* ORG_TYPE_OO */8,
                                              tl: {
                                                hd: /* ORG_TYPE_GP */9,
                                                tl: {
                                                  hd: /* ORG_TYPE_PERSON */10,
                                                  tl: {
                                                    hd: /* ORG_TYPE_OTHER */11,
                                                    tl: /* [] */0
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }, (function (index, ot) {
                                  const Key = "ot-" + String(index);
                                  return JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                    children: Buhta_cabinet__Org.Type.toString(ot)
                                                  }),
                                              className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                              onClick: (function (param) {
                                                  Curry._1(onOrgTypeSelect, ot);
                                                  Curry._1(setIsDropdownShown, (function (param) {
                                                          return false;
                                                        }));
                                                })
                                            }, Key);
                                }))),
                      className: "py-2 flex flex-col"
                    })
              });
  };
}

function Dropdowns$OrgTypeSelect(Props) {
  return make(Props.org_type)(Props.onOrgTypeSelect);
}

const OrgTypeSelect = {
  make: Dropdowns$OrgTypeSelect
};

function make$1(taxMode) {
  return function (onTaxModeSelect) {
    return function (errorOpt) {
      const error = errorOpt !== undefined ? errorOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const isDropdownShown = match[0];
      const activator = function (param) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                    children: Buhta_cabinet__TaxMode.Type.toString(taxMode)
                                  }),
                              isDropdownShown ? JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/select-arrows-links.svg")
                                    }) : JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                    }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                    children: "Режим налогообложения"
                                  })
                            ],
                            className: Cn.$plus("rounded border border-gray-main px-4 py-[11px] mt-6 flex justify-between relative items-center", Cn.on("border-links", isDropdownShown))
                          }),
                      error !== "" ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-alert",
                                    children: error
                                  }),
                              className: "px-4 mt-1"
                            }) : null
                    ]
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white mt-2",
                  isDropdownShown: isDropdownShown,
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                  hd: /* TAX_MODE_STANDARD */1,
                                  tl: {
                                    hd: /* TAX_MODE_KAZ_SNR_USN */4,
                                    tl: {
                                      hd: /* TAX_MODE_KAZ_SNR_RETAIL */7,
                                      tl: {
                                        hd: /* TAX_MODE_KAZ_SNR_PATENT */2,
                                        tl: {
                                          hd: /* TAX_MODE_KAZ_SNR_MOBILE */8,
                                          tl: {
                                            hd: /* TAX_MODE_KAZ_SNR_FIXED */3,
                                            tl: {
                                              hd: /* TAX_MODE_KAZ_SNR_FARMING_LAND */5,
                                              tl: {
                                                hd: /* TAX_MODE_KAZ_SNR_FARMING_PRODUCE */6,
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }, (function (index, tm) {
                                    const Key = "ot-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: Buhta_cabinet__TaxMode.Type.toString(tm)
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onTaxModeSelect, tm);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col"
                      })
                });
    };
  };
}

function Dropdowns$TaxModeSelect(Props) {
  return Curry._1(make$1(Props.taxMode)(Props.onTaxModeSelect), Props.error);
}

const TaxModeSelect = {
  make: Dropdowns$TaxModeSelect
};

const hrmEvents = {
  hd: {
    name: "Начало работы",
    code: "START"
  },
  tl: {
    hd: {
      name: "Изменение",
      code: "CHANGE"
    },
    tl: {
      hd: {
        name: "Увольнение",
        code: "TERMINATION"
      },
      tl: /* [] */0
    }
  }
};

function make$2(hrmEvent) {
  return function (onHrmEventSelect) {
    return function (errorOpt) {
      const error = errorOpt !== undefined ? errorOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const isDropdownShown = match[0];
      const activator = function (param) {
        let tmp;
        switch (hrmEvent) {
          case "CHANGE" :
              tmp = "Изменение";
              break;
          case "START" :
              tmp = "Начало работы";
              break;
          case "TERMINATION" :
              tmp = "Увольнение";
              break;
          default:
            tmp = "";
        }
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                    children: tmp
                                  }),
                              isDropdownShown ? JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/select-arrows-links.svg")
                                    }) : JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                    }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                    children: "Выберите событие"
                                  })
                            ],
                            className: Cn.$plus("rounded border border-gray-main px-4 py-[11px] flex justify-between relative items-center", Cn.on("border-links", isDropdownShown))
                          }),
                      error !== "" ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-alert",
                                    children: error
                                  }),
                              className: "px-4 mt-1"
                            }) : null
                    ],
                    className: Cn.$plus("px-6 py-4", Cn.on("pb-1", isDropdownShown))
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  innerClassName: "relative",
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white mx-6 mb-1",
                  isDropdownShown: isDropdownShown,
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(hrmEvents, (function (index, $$event) {
                                    const Key = "ot-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: $$event.name
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onHrmEventSelect, $$event.code);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col"
                      })
                });
    };
  };
}

function Dropdowns$HrmEventsSelect(Props) {
  return Curry._1(make$2(Props.hrmEvent)(Props.onHrmEventSelect), Props.error);
}

const HrmEventsSelect = {
  hrmEvents: hrmEvents,
  make: Dropdowns$HrmEventsSelect
};

function make$3(bank_id) {
  return function (onBankSelect) {
    const match = React.useState(function () {
          return false;
        });
    const setIsDropdownShown = match[1];
    const isDropdownShown = match[0];
    const match$1 = Buhta_core__GrpcState.useGrid(Buhta_cabinet__Bisb.BankService.getBanks, undefined);
    const dispatch = match$1[1];
    const grid = match$1[0];
    React.useEffect((function () {
            Curry._3(dispatch, undefined, undefined, undefined);
          }), []);
    let bankName;
    if (bank_id === 0 || typeof grid === "string" || grid.NAME !== "Data") {
      bankName = "Не указан";
    } else {
      try {
        bankName = Stdlib__List.find((function (b) {
                return b.id === bank_id;
              }), grid.VAL).name;
      }
      catch (exn){
        bankName = "Не указан";
      }
    }
    const activator = function (param) {
      return JsxRuntime.jsxs("div", {
                  children: [
                    bankName === "Не указан" ? JsxRuntime.jsx(Buhta_components__Text.P.make, {
                            className: "text-gray-medium",
                            children: "Банк"
                          }) : JsxRuntime.jsx(Buhta_components__Text.P.make, {
                            children: bankName
                          }),
                    isDropdownShown ? JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            src: StaticAsset.src("/static/icons/select-arrows-links.svg")
                          }) : JsxRuntime.jsx("img", {
                            className: "w-5 h-5",
                            src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                          })
                  ],
                  className: Cn.$plus("rounded border border-gray-main px-4 py-[9px] flex justify-between relative items-center", Cn.on("border-links", isDropdownShown))
                });
    };
    if (typeof grid === "string" || grid.NAME !== "Data") {
      return null;
    } else {
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  innerClassName: "mt-1",
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: isDropdownShown,
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(grid.VAL, (function (index, b) {
                                    const Key = "b-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.P.make, {
                                                      children: b.name
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onBankSelect, b);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col max-h-96 overflow-y-auto"
                      })
                });
    }
  };
}

function Dropdowns$BankSelect(Props) {
  return make$3(Props.bank_id)(Props.onBankSelect);
}

const BankSelect = {
  make: Dropdowns$BankSelect
};

function make$4(kogd) {
  return function (onKogdSelect) {
    return function (label) {
      return function (classNameOpt) {
        const className = classNameOpt !== undefined ? classNameOpt : "";
        const match = React.useState(function () {
              return "";
            });
        const setDisplayValue = match[1];
        const displayValue = match[0];
        const func = Buhta_cabinet__Kogd.KogdService.grid;
        const match$1 = Buhta_core__GrpcState.useGrid((function (param, param$1) {
                return Curry._3(func, param, param$1, "ru");
              }), undefined);
        const dispatch = match$1[1];
        const grid = match$1[0];
        let ogds;
        if (typeof grid === "string" || grid.NAME !== "Data") {
          ogds = /* [] */0;
        } else {
          const __x = Stdlib__List.sort((function (a, b) {
                  const match = a.parent;
                  if (match === undefined) {
                    return -1;
                  }
                  if (match === "0101") {
                    const match$1 = b.parent;
                    if (match$1 !== undefined) {
                      if (match$1 === "0101") {
                        return 0;
                      } else {
                        return -1;
                      }
                    } else {
                      return 1;
                    }
                  }
                  const match$2 = b.parent;
                  if (match$2 !== undefined && match$2 !== "0101") {
                    return 0;
                  } else {
                    return 1;
                  }
                }), grid.VAL);
          ogds = Belt__Belt_List.reduce(__x, /* [] */0, (function (acc, ogd) {
                  const match = ogd.parent;
                  if (match !== undefined) {
                    if (match === "0101") {
                      return Stdlib.$at(acc, {
                                  hd: [
                                    Stdlib__String.sub(ogd.code, 0, 2),
                                    {
                                      hd: ogd,
                                      tl: /* [] */0
                                    }
                                  ],
                                  tl: /* [] */0
                                });
                    } else {
                      return Stdlib__List.map((function (param) {
                                    const arr = param[1];
                                    const term = param[0];
                                    if (term === Stdlib__String.sub(ogd.code, 0, 2)) {
                                      return [
                                              term,
                                              Stdlib.$at(arr, {
                                                    hd: ogd,
                                                    tl: /* [] */0
                                                  })
                                            ];
                                    } else {
                                      return [
                                              term,
                                              arr
                                            ];
                                    }
                                  }), acc);
                    }
                  } else {
                    return Stdlib.$at(acc, {
                                hd: [
                                  "",
                                  {
                                    hd: ogd,
                                    tl: /* [] */0
                                  }
                                ],
                                tl: /* [] */0
                              });
                  }
                }));
        }
        React.useEffect((function () {
                Curry._3(dispatch, undefined, undefined, undefined);
              }), []);
        React.useEffect((function () {
                let exit = 0;
                if (typeof grid === "string" || grid.NAME !== "Data") {
                  exit = 1;
                } else {
                  let ogd;
                  try {
                    ogd = Stdlib__List.find((function (ogd) {
                            return ogd.code === kogd;
                          }), grid.VAL);
                  }
                  catch (exn){
                    ogd = Buhta_cabinet__Kogd.default;
                  }
                  if (ogd.code !== "") {
                    Curry._1(setDisplayValue, (function (param) {
                            return ogd.code + (" - " + ogd.name);
                          }));
                  }
                  
                }
                if (exit === 1) {
                  Curry._1(setDisplayValue, (function (param) {
                          return "";
                        }));
                }
                
              }), [
              grid,
              kogd
            ]);
        const match$2 = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match$2[1];
        const isDropdownShown = match$2[0];
        const activator = function (param) {
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                              children: displayValue
                            }),
                        isDropdownShown ? JsxRuntime.jsx("img", {
                                className: "w-5 h-5",
                                src: StaticAsset.src("/static/icons/select-arrows-links.svg")
                              }) : JsxRuntime.jsx("img", {
                                className: "w-5 h-5",
                                src: StaticAsset.src("/static/icons/select-arrows-gray.svg")
                              }),
                        label !== "" ? JsxRuntime.jsx("label", {
                                children: label,
                                className: Cn.$plus("absolute -top-[8px] left-[9px] px-2 text-asphalt transition-transform ease-in-out duration-250 bg-white", isDropdownShown || displayValue !== "" ? "text-preheader translate-y-0" : "text-sm translate-y-[18px]")
                              }) : null
                      ],
                      className: Cn.$plus(Cn.$plus("rounded border border-gray-main px-4 py-[11px] mt-6 flex justify-between relative items-center focus:outline-none", className), Cn.on("border-links", isDropdownShown))
                    });
        };
        return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                    align: "BottomCenter",
                    activator: activator,
                    background: "bg-white mt-2",
                    isDropdownShown: isDropdownShown,
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsx("div", {
                          children: typeof grid === "string" || grid.NAME !== "Data" ? "Загрузка..." : JsxRuntime.jsx(Buhta_cabinet__ClassifiersKogdList.make, {
                                  ogds: ogds,
                                  onKogdSelect: onKogdSelect,
                                  setIsDropdownShown: setIsDropdownShown
                                }),
                          className: "py-2 flex flex-col h-[400px] overflow-y-auto"
                        })
                  });
      };
    };
  };
}

function Dropdowns$KogdSelect(Props) {
  return Curry._2(make$4(Props.kogd)(Props.onKogdSelect), Props.label, Props.className);
}

const KogdSelect = {
  make: Dropdowns$KogdSelect
};

function make$5(year) {
  return function (onYearSelect) {
    return function (errorOpt) {
      const error = errorOpt !== undefined ? errorOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const activator = function (param) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                    children: String(year)
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                    children: "Год выпуска"
                                  })
                            ],
                            className: "rounded border border-gray-main px-4 py-[11px] flex justify-between relative items-center"
                          }),
                      error !== "" ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-alert",
                                    children: error
                                  }),
                              className: "px-4 mt-1"
                            }) : null
                    ],
                    className: "w-full"
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: match[0],
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                  hd: 2020,
                                  tl: {
                                    hd: 2021,
                                    tl: {
                                      hd: 2022,
                                      tl: {
                                        hd: 2023,
                                        tl: {
                                          hd: 2024,
                                          tl: /* [] */0
                                        }
                                      }
                                    }
                                  }
                                }, (function (index, y) {
                                    const Key = "year-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: String(y)
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onYearSelect, y);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col"
                      })
                });
    };
  };
}

function Dropdowns$YearSelect(Props) {
  return Curry._1(make$5(Props.year)(Props.onYearSelect), Props.error);
}

const YearSelect = {
  make: Dropdowns$YearSelect
};

function make$6(model) {
  return function (onModelSelect) {
    return function (errorOpt) {
      const error = errorOpt !== undefined ? errorOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      const activator = function (param) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                    children: model
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                    children: "Модель"
                                  })
                            ],
                            className: "rounded border border-gray-main px-4 py-[11px] flex justify-between relative items-center"
                          }),
                      error !== "" ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-alert",
                                    children: error
                                  }),
                              className: "px-4 mt-1"
                            }) : null
                    ],
                    className: "w-full"
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: match[0],
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex({
                                  hd: "Бухта 1.0",
                                  tl: /* [] */0
                                }, (function (index, m) {
                                    const Key = "model-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: m
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onModelSelect, m);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col"
                      })
                });
    };
  };
}

function Dropdowns$KkmModelSelect(Props) {
  return Curry._1(make$6(Props.model)(Props.onModelSelect), Props.error);
}

const KkmModelSelect = {
  make: Dropdowns$KkmModelSelect
};

const regions = {
  hd: {
    code: "750000000",
    name: "город Алматы"
  },
  tl: {
    hd: {
      code: "710000000",
      name: "город Астана"
    },
    tl: {
      hd: {
        code: "790000000",
        name: "город Шымкент"
      },
      tl: /* [] */0
    }
  }
};

function make$7(region) {
  return function (onRegionSelect) {
    return function (errorOpt) {
      const error = errorOpt !== undefined ? errorOpt : "";
      const match = React.useState(function () {
            return false;
          });
      const setIsDropdownShown = match[1];
      let currentRegion;
      try {
        currentRegion = Stdlib__List.find((function (rgn) {
                return rgn.code === region;
              }), regions);
      }
      catch (exn){
        currentRegion = {
          code: "",
          name: ""
        };
      }
      const activator = function (param) {
        return JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                    className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                    children: currentRegion.name
                                  }),
                              JsxRuntime.jsx("img", {
                                    className: "w-5 h-5",
                                    src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                  }),
                              JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                    children: "Область/Город"
                                  })
                            ],
                            className: "rounded border border-gray-main px-4 py-[11px] flex justify-between relative items-center"
                          }),
                      error !== "" ? JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                    className: "text-alert",
                                    children: error
                                  }),
                              className: "px-4 mt-1"
                            }) : null
                    ],
                    className: "w-full"
                  });
      };
      return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                  align: "BottomCenter",
                  activator: activator,
                  background: "bg-white",
                  isDropdownShown: match[0],
                  setIsDropdownShown: setIsDropdownShown,
                  children: JsxRuntime.jsx("div", {
                        children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(regions, (function (index, rgn) {
                                    const Key = "region-" + String(index);
                                    return JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                      children: rgn.name
                                                    }),
                                                className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                onClick: (function (param) {
                                                    Curry._1(onRegionSelect, rgn.code);
                                                    Curry._1(setIsDropdownShown, (function (param) {
                                                            return false;
                                                          }));
                                                  })
                                              }, Key);
                                  }))),
                        className: "py-2 flex flex-col"
                      })
                });
    };
  };
}

function Dropdowns$RegionSelect(Props) {
  return Curry._1(make$7(Props.region)(Props.onRegionSelect), Props.error);
}

const RegionSelect = {
  regions: regions,
  make: Dropdowns$RegionSelect
};

const cities = {
  hd: {
    code: "751310000",
    name: "район Ауэзовский",
    region: "750000000"
  },
  tl: {
    hd: {
      code: "751410000",
      name: "район Бостандыкский",
      region: "750000000"
    },
    tl: {
      hd: {
        code: "751510000",
        name: "район Жетысуский",
        region: "750000000"
      },
      tl: {
        hd: {
          code: "751110000",
          name: "район Алмалинский",
          region: "750000000"
        },
        tl: {
          hd: {
            code: "751910000",
            name: "район Турксибский",
            region: "750000000"
          },
          tl: {
            hd: {
              code: "751710000",
              name: "район Медеуский",
              region: "750000000"
            },
            tl: {
              hd: {
                code: "751210000",
                name: "район Алатауский",
                region: "750000000"
              },
              tl: {
                hd: {
                  code: "751810000",
                  name: "район Наурызбайский",
                  region: "750000000"
                },
                tl: {
                  hd: {
                    code: "711110000",
                    name: "район Алматы",
                    region: "710000000"
                  },
                  tl: {
                    hd: {
                      code: "711410000",
                      name: "район Байконыр",
                      region: "710000000"
                    },
                    tl: {
                      hd: {
                        code: "711210000",
                        name: "район Есиль",
                        region: "710000000"
                      },
                      tl: {
                        hd: {
                          code: "711510000",
                          name: "район Нұра",
                          region: "710000000"
                        },
                        tl: {
                          hd: {
                            code: "711310000",
                            name: "район Сарыарка",
                            region: "710000000"
                          },
                          tl: {
                            hd: {
                              code: "791110000",
                              name: "район Абайский",
                              region: "790000000"
                            },
                            tl: {
                              hd: {
                                code: "791310000",
                                name: "район Аль-Фарабийский",
                                region: "790000000"
                              },
                              tl: {
                                hd: {
                                  code: "791510000",
                                  name: "район Енбекшинский",
                                  region: "790000000"
                                },
                                tl: {
                                  hd: {
                                    code: "791710000",
                                    name: "район Каратау",
                                    region: "790000000"
                                  },
                                  tl: {
                                    hd: {
                                      code: "791910000",
                                      name: "район Тұран",
                                      region: "790000000"
                                    },
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

function make$8(region) {
  return function (city) {
    return function (onCitySelect) {
      return function (errorOpt) {
        const error = errorOpt !== undefined ? errorOpt : "";
        const match = React.useState(function () {
              return false;
            });
        const setIsDropdownShown = match[1];
        let currentCity;
        try {
          currentCity = Stdlib__List.find((function (ct) {
                  return ct.code === city;
                }), cities);
        }
        catch (exn){
          currentCity = {
            code: "",
            name: "",
            region: ""
          };
        }
        const activator = function (param) {
          return JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                      className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                      children: currentCity.name
                                    }),
                                JsxRuntime.jsx("img", {
                                      className: "w-5 h-5",
                                      src: StaticAsset.src("/static/icons/select-arrows-black-20.svg")
                                    }),
                                JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "absolute -top-2.5 left-2 bg-white px-2 text-gray-medium",
                                      children: "Город/Район"
                                    })
                              ],
                              className: "rounded border border-gray-main px-4 py-[11px] flex justify-between relative items-center"
                            }),
                        error !== "" ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                      className: "text-alert",
                                      children: error
                                    }),
                                className: "px-4 mt-1"
                              }) : null
                      ],
                      className: "w-full"
                    });
        };
        const __x = Stdlib__List.filter((function (ct) {
                return ct.region === region;
              }), cities);
        return JsxRuntime.jsx(Buhta_cabinet__Dropdown.Custom.make, {
                    align: "BottomCenter",
                    activator: activator,
                    background: "bg-white",
                    isDropdownShown: match[0],
                    setIsDropdownShown: setIsDropdownShown,
                    children: JsxRuntime.jsx("div", {
                          children: Belt__Belt_List.toArray(Belt__Belt_List.mapWithIndex(__x, (function (index, city) {
                                      const Key = "model-" + String(index);
                                      return JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                        children: city.name
                                                      }),
                                                  className: "flex items-center space-x-2 px-4 py-1.5 hover:bg-gray-light cursor-pointer",
                                                  onClick: (function (param) {
                                                      Curry._1(onCitySelect, city.code);
                                                      Curry._1(setIsDropdownShown, (function (param) {
                                                              return false;
                                                            }));
                                                    })
                                                }, Key);
                                    }))),
                          className: "py-2 flex flex-col"
                        })
                  });
      };
    };
  };
}

function Dropdowns$CitySelect(Props) {
  return Curry._2(make$8(Props.region)(Props.city), Props.onCitySelect, Props.error);
}

const CitySelect = {
  cities: cities,
  make: Dropdowns$CitySelect
};

export {
  CountrySelect ,
  OrgTypeSelect ,
  TaxModeSelect ,
  HrmEventsSelect ,
  BankSelect ,
  KogdSelect ,
  YearSelect ,
  KkmModelSelect ,
  RegionSelect ,
  CitySelect ,
}
/* countries Not a pure module */
